/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import { ItemTagFragment } from '../../Tag/types/ItemTagFragment'
import { ItemQuestionsFragment } from './ItemQuestionsFragment'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type LocationItemQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']
}>

export type LocationItemQuery = {
  __typename: 'Query'
  locationItem: {
    __typename: 'LocationItem'
    id: number
    item: {
      __typename: 'Item'
      id: number
      name: string
      hasSpecialInstructions: boolean
      description: string | null
      tags: Array<{
        __typename: 'ItemTag'
        id: string
        name: string
        imageSvgUrl: string | null
        highlighted: boolean
        color: string
      }>
      price: { __typename: 'Money'; formatted: string; cents: number }
      image: { __typename: 'ItemImage'; medium: string; high: string }
    }
    locationItemQuestions: Array<{
      __typename: 'LocationItemQuestion'
      id: number
      status: Types.LocationItemStatus
      text: string
      itemQuestion: {
        __typename: 'ItemQuestion'
        id: number
        text: string
        questionType: Types.ItemQuestionType
        questionTypeId: number
        required: boolean | null
        maxAnswers: number | null
      }
      locationItemAnswers: Array<{
        __typename: 'LocationItemAnswer'
        id: number
        status: Types.LocationItemStatus
        itemAnswer: {
          __typename: 'ItemAnswer'
          id: number
          active: boolean | null
          text: string | null
          default: boolean
          adjustment: {
            __typename: 'Money'
            cents: number
            formatted: string
          } | null
        }
      }> | null
    }>
  }
}

export const LocationItemQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LocationItemQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locationItem' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'item' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'tags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'ItemTagFragment' }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'ItemQuestionsFragment' }
                }
              ]
            }
          }
        ]
      }
    },
    ...ItemTagFragment.definitions,
    ...ItemQuestionsFragment.definitions
  ]
} as unknown as DocumentNode

/**
 * __useLocationItemQuery__
 *
 * To run a query within a React component, call `useLocationItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useLocationItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLocationItemQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLocationItemQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LocationItemQuery,
    LocationItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LocationItemQuery,
    LocationItemQueryVariables
  >(LocationItemQueryDocument, options)
}
export function useLocationItemQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LocationItemQuery,
    LocationItemQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LocationItemQuery,
    LocationItemQueryVariables
  >(LocationItemQueryDocument, options)
}
export type LocationItemQueryHookResult = ReturnType<
  typeof useLocationItemQuery
>
export type LocationItemQueryLazyQueryHookResult = ReturnType<
  typeof useLocationItemQueryLazyQuery
>
export type LocationItemQueryQueryResult = Apollo.QueryResult<
  LocationItemQuery,
  LocationItemQueryVariables
>
